import { configure } from "mobx";
import { createContext, useContext } from "react";

import MerchantStroe from "./merchant";

configure({ enforceActions: "never" });

export const merchantStroe = new MerchantStroe();

function createStores() {
  return {
    merchantStroe,
  };
}
const stores = createStores();

export const StoresContext = createContext(stores);

const useStores = () => useContext(StoresContext);

export { stores, useStores };
